module.exports = __webpack_public_path__ + "images/hangersb983bc51cfc726e269fbc3fca5539639.png";